import client from 'integration/client'

import { ResetPasswordPayload, SendEmailResetPasswordPayload } from './types'

export const sendEmailResetPassword = (data: SendEmailResetPasswordPayload) =>
  client.post('v1/users/reset-password/', data)

export const resetPassword = ({ id, ...data }: ResetPasswordPayload) =>
  client.post(`v1/users/${id}/reset-password`, data)
